/**
 * Site Header — scroll detection, mobile menu, mega menu hover, search toggle
 */
(function () {
  'use strict';

  var header = document.getElementById('site-header');
  var menuToggle = document.querySelector('[data-header-menu-toggle]');
  var searchToggle = document.querySelector('[data-header-search-toggle]');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileSearch = document.getElementById('mobile-search');
  var categoriesToggle = document.querySelector('[data-mobile-categories-toggle]');
  var categoriesPanel = document.getElementById('mobile-categories');
  var overlay = document.getElementById('mega-menu-overlay');

  // Set --header-height CSS variable for mega menu positioning
  function updateHeaderHeight() {
    if (header) {
      document.documentElement.style.setProperty(
        '--header-height',
        header.offsetHeight + 'px'
      );
    }
  }
  updateHeaderHeight();

  // Scroll detection for sticky header style
  var scrolled = false;
  function onScroll() {
    var isScrolled = window.scrollY > 10;
    if (isScrolled !== scrolled) {
      scrolled = isScrolled;
      if (scrolled) {
        header.classList.remove('bg-white/80', 'border-brand-border/40');
        header.classList.add('bg-white/90', 'shadow-sm', 'border-brand-border/60');
      } else {
        header.classList.remove('bg-white/90', 'shadow-sm', 'border-brand-border/60');
        header.classList.add('bg-white/80', 'border-brand-border/40');
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Mobile menu toggle
  var menuOpen = false;

  /* Single owner for the drawer's open state. There are four places that close
     it (the button, the search toggle, a resize to desktop, and any drawer
     opening) and three of them used to reset the icon through selectors that
     were not in the markup, while leaving aria-expanded saying "true". The
     icon is CSS off aria-expanded now, so this has to be the only writer.

     keepBodyLock is for the drawer case: the drawer has just taken the body
     lock for itself, and clearing it here would let the page scroll behind it. */
  function setMenuOpen(open, keepBodyLock) {
    if (!mobileMenu) return;
    menuOpen = open;
    mobileMenu.classList.toggle('hidden', !open);
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!keepBodyLock) document.body.style.overflow = open ? 'hidden' : '';
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      setMenuOpen(!menuOpen);
      // Close search if open
      if (menuOpen && mobileSearch) {
        mobileSearch.classList.add('hidden');
      }
    });
  }

  // Mobile search toggle
  var searchOpen = false;
  if (searchToggle && mobileSearch) {
    searchToggle.addEventListener('click', function () {
      searchOpen = !searchOpen;
      mobileSearch.classList.toggle('hidden', !searchOpen);
      if (searchOpen) {
        var input = mobileSearch.querySelector('input');
        if (input) input.focus();
        // Close menu if open
        if (menuOpen) setMenuOpen(false);
      }
    });
  }

  // All Categories accordion in mobile menu
  if (categoriesToggle && categoriesPanel) {
    var catOpen = false;
    categoriesToggle.addEventListener('click', function () {
      catOpen = !catOpen;
      categoriesPanel.classList.toggle('hidden', !catOpen);
      var chevron = categoriesToggle.querySelector('[data-chevron]');
      if (chevron) {
        chevron.style.transform = catOpen ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    });
  }

  // ── Mobile nested accordion (+/- expanders, any depth) ──
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mm-toggle]');
      if (!btn) return;
      var row = btn.closest('.mm-row');
      var panel = row && row.nextElementSibling;
      if (panel && panel.classList.contains('mm-panel')) {
        var open = panel.classList.toggle('is-open');
        /* A row has two ways to open it now, the label and the +/-, so the
           state goes on both. Setting it only on the one that was tapped
           leaves the other announcing the opposite of what is on screen. */
        row.querySelectorAll('[data-mm-toggle]').forEach(function (t) {
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    });
  }

  // ——— Desktop mega menu ———
  var dropdowns = document.querySelectorAll('[data-nav-dropdown]');
  var activeDropdown = null;
  var dropdownTimeout = null;
  var CLOSE_DELAY = 200;

  function openMegaMenu(dropdown) {
    var panel = dropdown.querySelector('[data-nav-panel]');
    var chevron = dropdown.querySelector('[data-nav-chevron]');
    if (!panel) return;

    // Close previous if different
    if (activeDropdown && activeDropdown !== dropdown) {
      closeMegaMenu(activeDropdown, true);
    }

    panel.classList.remove('opacity-0', 'invisible', 'translate-y-1');
    panel.classList.add('opacity-100', 'visible', 'translate-y-0');
    if (chevron) chevron.style.transform = 'rotate(180deg)';

    // Show overlay
    if (overlay) {
      overlay.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
      overlay.classList.add('opacity-100', 'visible', 'pointer-events-auto');
    }

    activeDropdown = dropdown;
    var trigger = dropdown.querySelector('[data-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMegaMenu(dropdown, immediate) {
    var trigger = dropdown.querySelector('[data-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    var panel = dropdown.querySelector('[data-nav-panel]');
    var chevron = dropdown.querySelector('[data-nav-chevron]');
    if (panel) {
      panel.classList.add('opacity-0', 'invisible', 'translate-y-1');
      panel.classList.remove('opacity-100', 'visible', 'translate-y-0');
    }
    if (chevron) chevron.style.transform = '';

    // Hide overlay only if no other dropdown is active
    if (!immediate && overlay) {
      overlay.classList.remove('opacity-100', 'visible', 'pointer-events-auto');
      overlay.classList.add('opacity-0', 'invisible', 'pointer-events-none');
    }
  }

  function closeAllMegaMenus() {
    dropdowns.forEach(function (dd) {
      closeMegaMenu(dd, true);
    });
    activeDropdown = null;
    if (overlay) {
      overlay.classList.remove('opacity-100', 'visible', 'pointer-events-auto');
      overlay.classList.add('opacity-0', 'invisible', 'pointer-events-none');
    }
  }

  dropdowns.forEach(function (dropdown) {
    var panel = dropdown.querySelector('[data-nav-panel]');
    if (!panel) return;

    // Hover on trigger area (the nav item wrapper)
    dropdown.addEventListener('mouseenter', function () {
      if (dropdownTimeout) {
        clearTimeout(dropdownTimeout);
        dropdownTimeout = null;
      }
      openMegaMenu(dropdown);
    });

    // Keyboard: open mega menu on focusin (Tab into trigger)
    dropdown.addEventListener('focusin', function () {
      if (dropdownTimeout) {
        clearTimeout(dropdownTimeout);
        dropdownTimeout = null;
      }
      openMegaMenu(dropdown);
    });

    dropdown.addEventListener('mouseleave', function () {
      dropdownTimeout = setTimeout(function () {
        closeMegaMenu(dropdown, false);
        activeDropdown = null;
      }, CLOSE_DELAY);
    });

    // Keyboard: close mega menu when focus leaves the dropdown entirely
    dropdown.addEventListener('focusout', function (e) {
      if (!dropdown.contains(e.relatedTarget)) {
        dropdownTimeout = setTimeout(function () {
          closeMegaMenu(dropdown, false);
          activeDropdown = null;
        }, CLOSE_DELAY);
      }
    });

    // Keep panel open when hovering the mega menu panel itself
    panel.addEventListener('mouseenter', function () {
      if (dropdownTimeout) {
        clearTimeout(dropdownTimeout);
        dropdownTimeout = null;
      }
    });

    panel.addEventListener('mouseleave', function () {
      dropdownTimeout = setTimeout(function () {
        closeMegaMenu(dropdown, false);
        activeDropdown = null;
      }, CLOSE_DELAY);
    });

    /* The trigger is a button now, so a click no longer navigates anywhere.
       That leaves touch devices with no way in: a tablet at desktop width
       never fires a reliable mouseenter, and the old markup only worked there
       because the click followed the href. Toggle explicitly so tap opens the
       panel, tapping the same item again closes it, and Enter or Space work
       for keyboard users. */
    var navTrigger = dropdown.querySelector('[data-nav-trigger]');
    if (navTrigger && navTrigger.tagName === 'BUTTON') {
      navTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (dropdownTimeout) {
          clearTimeout(dropdownTimeout);
          dropdownTimeout = null;
        }
        if (activeDropdown === dropdown) {
          closeMegaMenu(dropdown, false);
          activeDropdown = null;
        } else {
          openMegaMenu(dropdown);
        }
      });
    }
  });

  // Close on overlay click
  if (overlay) {
    overlay.addEventListener('click', closeAllMegaMenus);
  }

  // Close dropdowns on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeDropdown) {
      closeAllMegaMenus();
    }
  });

  // Mobile sub-nav accordions
  var subnavToggles = document.querySelectorAll('[data-mobile-subnav-toggle]');
  subnavToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.parentElement.querySelector('[data-mobile-subnav]');
      var chevron = btn.querySelector('[data-subnav-chevron]');
      if (!panel) return;
      var isOpen = !panel.classList.contains('hidden');
      panel.classList.toggle('hidden', isOpen);
      if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
    });
  });

  // Combined, rAF-throttled resize handler (prevents layout thrashing)
  var resizeRafPending = false;
  window.addEventListener('resize', function () {
    if (resizeRafPending) return;
    resizeRafPending = true;
    requestAnimationFrame(function () {
      resizeRafPending = false;
      // Update header height CSS variable
      updateHeaderHeight();
      // Close mobile menu on resize to desktop
      if (window.innerWidth >= 1024 && menuOpen) {
        setMenuOpen(false);
      }
      // Also close mega menus on resize
      closeAllMegaMenus();
    });
  });

  // Close mega menus and mobile menu when any drawer opens
  document.addEventListener('drawer:request-close', function () {
    closeAllMegaMenus();
    if (menuOpen) setMenuOpen(false, true);
    if (searchOpen && mobileSearch) {
      searchOpen = false;
      mobileSearch.classList.add('hidden');
    }
  });

  // Cart badge is now managed by cart-drawer.js
})();
